import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -14","key":"svg-0"}]]

const IconSquareDashed = createReactComponent('outline', 'square-dashed', 'SquareDashed', __iconNode);

export default IconSquareDashed;